import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import Immutable from 'immutable';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { Provider as ReduxProvider } from 'react-redux'

import { initReduxStore, initApolloClient } from 'helpers';
import { unregister } from './helpers/registerServiceWorker';
import App from './App';
import routes from './routes';


// Activate immutable-devtools to make Immutable objects print nicer in Chrome
// console for better debugging experience.
if (process.env.NODE_ENV !== 'production') {
  const installDevTools = require('immutable-devtools');
  installDevTools(Immutable);
}

// NOTE(tyu): Don't use initialState at root level,
// instead set the initial state at each sub reducer level.
const store = initReduxStore();
const client = initApolloClient();

ReactDOM.render(
  <ReduxProvider store={store}>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <App routes={routes} />
      </BrowserRouter>
    </ApolloProvider>
  </ReduxProvider>,
  document.getElementById('root'),
);

// NOTE(thx): Disable SW for now:
// https://github.com/facebookincubator/create-react-app/issues/2398
// https://github.com/facebookincubator/create-react-app/blob/master/packages/react-scripts/template/README.md#opting-out-of-caching
// registerServiceWorker();
unregister();

export {
  store,
}



// WEBPACK FOOTER //
// ./src/index.js